// react
import * as React from 'react';
import { useState } from 'react';

import PropTypes from 'prop-types';

import { useSnackbar } from 'notistack';

// IconButton
import { Icon } from '@iconify/react';
import CloseIcon from '@iconify/icons-mdi/close-circle-outline';

import saveIcon from '@iconify/icons-eva/save-outline';

// material
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';

// local
import { useTranslation } from '../../common/LocalizationProvider';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <Icon icon={CloseIcon} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

EditMotionIgnitionDialog.propTypes = {
  positionId: PropTypes.number.isRequired,
  route: PropTypes.object.isRequired,
  refresh: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
};

export default function EditMotionIgnitionDialog({
  positionId,
  route,
  refresh,
  isOpen,
  setIsOpen
}) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isSubmitting, setSubmitting] = useState(false);

  const [motion, setMotion] = useState(
    route.attributes && route.attributes.motion ? route.attributes.motion : false
  );
  const [ignition, setIgnition] = useState(
    route.attributes && route.attributes.ignition ? route.attributes.ignition : false
  );

  const handleSubmit = async () => {
    setSubmitting(true);
    const response = await fetch(
      `/api/positions/motion/ignition/${positionId}/${motion}/${ignition}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }
    );

    if (response.ok) {
      enqueueSnackbar(t('DL_Snackbar_Change'), {
        variant: 'success'
      });
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }

    setSubmitting(false);
    setIsOpen(false);
    refresh();
  };

  return (
    <BootstrapDialog open={isOpen} onClose={() => setIsOpen(false)}>
      <BootstrapDialogTitle onClose={() => setIsOpen(false)}>{t('btn_Edit')}</BootstrapDialogTitle>
      <DialogContent dividers sx={{ width: window.innerHeight / 2.5 }}>
        <FormControl fullWidth sx={{ mt: 3 }}>
          <InputLabel id="ignition">{t('fields_Ignition')}</InputLabel>
          <Select
            labelId="ignition-select-label"
            id="ignition-select"
            value={ignition}
            label={t('fields_Ignition')}
            onChange={(event) => setIgnition(event.target.value)}
          >
            <MenuItem value={false}>false</MenuItem>
            <MenuItem value>true</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mt: 3 }}>
          <InputLabel id="motion">{t('fields_Motion')}</InputLabel>
          <Select
            labelId="motion-select-label"
            id="motion-select"
            value={motion}
            label={t('fields_Motion')}
            onChange={(event) => setMotion(event.target.value)}
          >
            <MenuItem value={false}>false</MenuItem>
            <MenuItem value>true</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          startIcon={<Icon icon={saveIcon} />}
          onClick={handleSubmit}
        >
          {t('btn_Save')}
        </LoadingButton>
      </DialogActions>
    </BootstrapDialog>
  );
}
